// App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Commission from './components/Commission';
import Monthly from './components/Monthly';
import './App.css';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Home page */}
        <Route path="/" element={<Monthly />} />

        {/* /monthly page */}
        <Route path="/monthly" element={<Commission />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
